module.exports = __webpack_public_path__ + "img/lupaBlanca.f1cb65c4.svg";